// extracted by mini-css-extract-plugin
module.exports = {"root":"DateNumberBody_root__2m9zF","inputCustom":"DateNumberBody_inputCustom__1lHiL","row":"DateNumberBody_row__2gd4V","item":"DateNumberBody_item__3stZQ"};